﻿/*
 * Globalize Culture it-IT
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("it-IT", "default", {
    name: "it-IT",
    englishName: "Italian (Italy)",
    nativeName: "italiano (Italia)",
    language: "it",
    numberFormat: {
      ",": ".",
      ".": ",",
      NaN: "Non un numero reale",
      negativeInfinity: "-Infinito",
      positiveInfinity: "+Infinito",
      percent: {
        pattern: ["-n%", "n%"],
        ",": ".",
        ".": ","
      },
      currency: {
        pattern: ["-$ n", "$ n"],
        ",": ".",
        ".": ",",
        symbol: "€"
      }
    },
    calendars: {
      standard: {
        firstDay: 1,
        days: {
          names: [
            "domenica",
            "lunedì",
            "martedì",
            "mercoledì",
            "giovedì",
            "venerdì",
            "sabato"
          ],
          namesAbbr: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
          namesShort: ["do", "lu", "ma", "me", "gi", "ve", "sa"]
        },
        months: {
          names: [
            "gennaio",
            "febbraio",
            "marzo",
            "aprile",
            "maggio",
            "giugno",
            "luglio",
            "agosto",
            "settembre",
            "ottobre",
            "novembre",
            "dicembre",
            ""
          ],
          namesAbbr: [
            "gen",
            "feb",
            "mar",
            "apr",
            "mag",
            "giu",
            "lug",
            "ago",
            "set",
            "ott",
            "nov",
            "dic",
            ""
          ]
        },
        AM: null,
        PM: null,
        eras: [{ name: "d.C.", start: null, offset: 0 }],
        patterns: {
          d: "dd/MM/yyyy",
          D: "dddd d MMMM yyyy",
          t: "HH:mm",
          T: "HH:mm:ss",
          f: "dddd d MMMM yyyy HH:mm",
          F: "dddd d MMMM yyyy HH:mm:ss",
          M: "dd MMMM",
          Y: "MMMM yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "Informazioni aggiuntive",
      AddNewTab: "Aggiungi nuova scheda",
      Alerts: "Avvisi",
      ApplyFilter: "Applica filtro",
      Approve: "Approva",
      Attachments: "Allegati",
      Back: "Indietro",
      Basic: "Di base",
      Between: "Compreso tra",
      Book: "Libro",
      Cancel: "Annulla",
      Checked: "Selezionato",
      ClearFilter: "Annulla filtro",
      Close: "Chiudi",
      CloseCancelChanges: "Chiudi e annulla modifiche",
      CloseSaveChanges: "Chiudi e salva modifiche",
      CloseTab: "Chiudi scheda",
      ColumnPersonalization: "Personalizzazione colonne",
      Comments: "Commenti",
      Confirmation: "Conferma",
      Contains: "Contiene",
      CreateTab: "Crea nuova scheda",
      Cut: "Taglia",
      Delete: "Elimina",
      DiscardUndo: "Ignora/Annulla",
      DisplayDropDownList: "Visualizza elenco a discesa",
      Displaying: "Visualizzazione corrente: ",
      DocWord: "Documento",
      DoesNotContain: "Non contiene",
      DoesNotEndWith: "Non finisce con",
      DoesNotEqual: "Diverso da",
      DoesNotStartWith: "Non inizia con",
      Download: "Scarica",
      Duplicate: "Duplica",
      Edit: "Modifica",
      EitherSelectedorNotSelected: "Selezionati o non selezionati",
      Email: "E-mail",
      EndsWith: "Finisce con",
      EqualsStr: "Uguale a",
      ExpandCollapse: "Espandi/Comprimi",
      ExportFailed: "Esportazione non riuscita",
      ExportToExcel: "Esporta in Excel",
      FileInUse: "Il file specificato è in uso",
      FileInUseDetail:
        "Chiudere il file nell\u0027applicazione in cui è in uso oppure specificare un altro nome file.",
      Filter: "Filtro",
      FilterMenu: "Menu filtro",
      FilterOptions: "Opzioni filtro",
      FilterWithinResults: "Filtra nei risultati",
      First: "Primo",
      FirstView: "Prima vista",
      Folder: "Cartella",
      ForgotPassword: "Password dimenticata?",
      Forward: "Avanti",
      GetMoreRows: "Ottieni altre righe",
      GreaterThan: "Maggiore di",
      GreaterThanOrEquals: "Maggiore o uguale a",
      GridSettings: "Impostazioni griglia",
      GroupSelection: "Selezione gruppo",
      Help: "Guida",
      HideColumn: "Nascondi colonna",
      IsEmpty: "È vuoto",
      IsNotEmpty: "Non è vuoto",
      Last: "Ultimo",
      LastView: "Ultima vista",
      LaunchActivate: "Avvia/Attiva",
      LessThan: "Minore di",
      LessThanOrEquals: "Minore o uguale a",
      Links: "Collegamenti",
      ListTabs: "Elenca tutte le schede",
      LoadingItem: "Caricamento elemento in corso ",
      Maintenance: "Gestione",
      Menu: "Menu",
      New: "Nuovo",
      Next: "Successivo",
      NextView: "Vista successiva",
      No: "No",
      NotChecked: "Non selezionato",
      Notes: "Note",
      NotSelected: "Non selezionati",
      Of: " di ",
      Ok: "OK",
      Open: "Apri",
      Password: "Password",
      Paste: "Incolla",
      Phone: "Telefono",
      PleaseWait: "Attendere",
      Previous: "Precedente",
      PreviousView: "Vista precedente",
      Print: "Stampa",
      Queries: "Query",
      Redo: "Ripeti",
      Refresh: "Aggiorna",
      Reject: "Rifiuta",
      RememberMe: "Memorizza nel computer in uso",
      Reports: "Report",
      Reset: "Reimposta",
      Review: "Rivedi",
      RunFilter: "Esegui filtro",
      RunJob: "Esegui processo",
      Save: "Salva",
      SaveBeforeClosing: "Salva prima di chiudere",
      SavedFilters: "Filtri salvati",
      SaveSubmit: "Salva/Inoltra",
      ScreenDesign: "Design schermo",
      Search: "Ricerca",
      SelectContents: "Seleziona contenuto",
      SelectDate: "Seleziona data",
      SelectDeselect: "Seleziona/Deseleziona tutto",
      Selected: "Selezione corrente: ",
      ServerName: "Nome server",
      Settings: "Impostazioni",
      ShowFilterRow: "Mostra riga filtro",
      SignIn: "Accesso",
      SortAscending: "Ordinamento crescente",
      SortDescending: "Ordinamento decrescente",
      Spreadsheet: "Foglio di lavoro",
      StartsWith: "Inizia con",
      StatusIndicator: "Indicatore di stato",
      Tasks: "Attività",
      Today: "Oggi",
      Translate: "Traduci",
      UserID: "ID utente",
      Utilities: "Utilità",
      Yes: "Sì",
      Page: "Pagina",
      Rows: "Righe",
      ShowingAll: "Visualizzazione completa",
      SessionNavigation: "Esplorazione della sessione",
      ListAllMenuItems: "Elenca tutte le voci di menu",
      NoRecordsFound: "Nessun record individuato",
      SearchTree: "Struttura di ricerca",
      Clear: "Cancella",
      DrillDown: "Visualizza dettagli",
      Required: "Questo campo è obbligatorio",
      Available: "Disponibile:",
      Add: "Aggiungi",
      MoveDown: "Sposta giù",
      MoveUp: "Sposta su",
      Remove: "Rimuovi",
      LastYear: "Ultimo anno",
      NextMonth: "Mese successivo",
      NextWeek: "Settimana successiva",
      NextYear: "Esercizio successivo",
      OneMonthAgo: "Un mese fa",
      OneWeekAgo: "Una settimana fa",
      SixMonthsAgo: "Sei mesi fa",
      Time: "Ora",
      CannotBeSelected: "Impossibile selezionare questa riga.",
      ResetToDefault: "Ripristina layout predefinito",
      CloseOtherTabs: "Chiudi le altre schede",
      EmailValidation: "Immettere un indirizzo e-mail valido",
      UrlValidation: "Immettere un URL valido",
      EndofResults: "Fine dei risultati",
      More: "Altro...",
      RecordsPerPage: "Record per pagina",
      Maximize: "Ingrandisci",
      Minimize: "Riduci a icona",
      CloseAllTabs: "Chiudi tutte le schede",
      QuickDates: "Selezione rapida data",
      Finish: "Fine",
      SetTextColor: "Imposta colore testo",
      AttachmentRules: "Regole allegati",
      AutoRefresh: "Aggiornamento automatico",
      BarChart: "Grafico a barre",
      CopyMail: "Copia e invia e-mail",
      CopyUrl: "Copia URL",
      DistributeHorizontally: "Distribuisci orizzontalmente",
      ExpandAll: "Espandi tutto",
      Generate: "Genera",
      GenerateScript: "Genera script",
      NoAttachments: "Nessun allegato",
      PieChart: "Grafico a torta",
      QuickAccess: "Accesso rapido",
      RestoreUser: "Ripristina utente",
      SaveConsolidate: "Salva con consolidamento locale",
      "Screen Design": "Struttura schermata",
      SelectAll: "Seleziona tutto",
      SpellCheck: "Controllo ortografico",
      SubmitForApproval: "Invia per approvazione",
      TopDownSpread: "Top Down Spread",
      Timezone: "Fuso orario",
      Loading: "Caricamento in corso...",
      NewNode: "Nuovo nodo"
    }
  });
})(this);
